"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Information = void 0;
var _jsxRuntime = require("react/jsx-runtime");
const Information = () => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M2 12C2 17.5158 6.48421 22 12 22C17.5158 22 22 17.5158 22 12C22 6.48421 17.5158 2 12 2C6.48421 2 2 6.48421 2 12ZM3.05263 12C3.05263 7.06316 7.06316 3.05263 12 3.05263C16.9368 3.05263 20.9474 7.06316 20.9474 12C20.9474 16.9368 16.9368 20.9474 12 20.9474C7.06316 20.9474 3.05263 16.9368 3.05263 12ZM11.985 8C11.79 8 11.595 7.92443 11.46 7.7733C11.325 7.63728 11.25 7.44081 11.25 7.24433C11.25 7.13854 11.25 7.04786 11.295 6.95718C11.34 6.8665 11.385 6.77582 11.46 6.71536C11.73 6.42821 12.24 6.42821 12.525 6.71536C12.6 6.77582 12.645 6.8665 12.69 6.95718C12.72 7.04786 12.75 7.13854 12.75 7.24433C12.75 7.44081 12.66 7.63728 12.525 7.7733C12.375 7.92443 12.18 8 11.985 8ZM12 9.5C12.2761 9.5 12.5 9.72386 12.5 10V17C12.5 17.2761 12.2761 17.5 12 17.5C11.7239 17.5 11.5 17.2761 11.5 17V10C11.5 9.72386 11.7239 9.5 12 9.5Z"
    })
  });
};
exports.Information = Information;